module.exports = __webpack_public_path__ + "img/unionpay.b5437877.png";